import { ComponentType, FC } from "react";
import * as _ from "lodash";

import { Charts } from "@ctra/components";
import { ExtendedEventEntity, EventCategory } from "@ctra/api";
import { useTranslation, Enterprise as Content } from "@ctra/i18n";

import { EventContext, eventCategoryMap } from "@events";

import styles from "./EventList.module.less";

const { EventList: Wrapper, EventEntry } = Charts;

interface EventListProps {
  data: ExtendedEventEntity[];
  handleClose?: () => void;
}

/**
 * Event list
 * @param {string} date
 * @return {JSX.Element}
 * @constructor
 */
export const EventList: FC<EventListProps> = ({ data, handleClose }) => {
  const { t } = useTranslation();

  const {
    events: { list }
  } = Content;

  /**
   * Get icon
   * @param {EventCategory} category
   * @return {React.ComponentType}
   */
  const getIcon = (category: EventCategory): ComponentType => {
    const [, icon] = eventCategoryMap[category];

    return icon;
  };

  return (
    <Wrapper
      title={t(list.header)}
      handleClose={handleClose}
      className={styles.List}
      dataSource={data}
      // @ts-ignore
      renderItem={({ id }) => (
        <EventContext.Provider eventID={id} key={id}>
          <EventContext.Consumer>
            {/* @ts-ignore */}
            {({ getTitle, getDescription, getStartMoment, getEndMoment, event: { category } }) => (
              <EventEntry
                icon={getIcon(category)}
                title={getTitle()}
                description={_.trim(getDescription())}
                start={getStartMoment()}
                end={getEndMoment()}
              />
            )}
          </EventContext.Consumer>
        </EventContext.Provider>
      )}
    />
  );
};
